import React from 'react';


export const RouteContext = React.createContext(null);
